<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="" prop="userId">
          <el-input v-model="dataForm.userId" placeholder=""></el-input>
      </el-form-item>
          <el-form-item label="" prop="userIp">
          <el-input v-model="dataForm.userIp" placeholder=""></el-input>
      </el-form-item>
          <el-form-item label="" prop="userAgent">
          <el-input v-model="dataForm.userAgent" placeholder=""></el-input>
      </el-form-item>
          <el-form-item label="访问时间" prop="visitTime">
          <el-input v-model="dataForm.visitTime" placeholder="访问时间"></el-input>
      </el-form-item>
              <el-form-item label="更新者" prop="updater">
          <el-input v-model="dataForm.updater" placeholder="更新者"></el-input>
      </el-form-item>
          <el-form-item label="更新时间" prop="updateDate">
          <el-input v-model="dataForm.updateDate" placeholder="更新时间"></el-input>
      </el-form-item>
          <el-form-item label="" prop="visitUrl">
          <el-input v-model="dataForm.visitUrl" placeholder=""></el-input>
      </el-form-item>
          <el-form-item label="" prop="visitCity">
          <el-input v-model="dataForm.visitCity" placeholder=""></el-input>
      </el-form-item>
          <el-form-item label="" prop="province">
          <el-input v-model="dataForm.province" placeholder=""></el-input>
      </el-form-item>
          <el-form-item label="" prop="ipResp">
          <el-input v-model="dataForm.ipResp" placeholder=""></el-input>
      </el-form-item>
          <el-form-item label="运营机构ID" prop="operationId">
          <el-input v-model="dataForm.operationId" placeholder="运营机构ID"></el-input>
      </el-form-item>
          <el-form-item label="投放渠道ID" prop="channelId">
          <el-input v-model="dataForm.channelId" placeholder="投放渠道ID"></el-input>
      </el-form-item>
          <el-form-item label="页面ID" prop="pageId">
          <el-input v-model="dataForm.pageId" placeholder="页面ID"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        userId: '',
        userIp: '',
        userAgent: '',
        visitTime: '',
        creator: '',
        createDate: '',
        updater: '',
        updateDate: '',
        visitUrl: '',
        visitCity: '',
        province: '',
        ipResp: '',
        operationId: '',
        channelId: '',
        pageId: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        userId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        userIp: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        userAgent: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        visitTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updater: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        visitUrl: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        visitCity: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        province: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        ipResp: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        operationId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        channelId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        pageId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/uservisitrecords0512archive/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/uservisitrecords0512archive/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
